<app-document-viewer [loadingData]="loading()" class="animated fadeIn">
  <!-- ── 1. Header Section ── -->
  <div class="card-report user-info-section mb-2">
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div class="d-flex align-items-center gap-2">
        <div class="header-icon-container">
          <i class="fa fa-building-o" style="color: #2563eb; font-size: 16px;"></i>
        </div>
        <div>
          <span class="client-id-badge">{{ resumeData.clientInfomationTabData()?.ident_GUI || 'N/A' }}</span>
          <h2 class="client-title">{{ (resumeData.clientInfomationTabData()?.name_client || 'Client Name') | titlecase }}</h2>
        </div>
      </div>

      @if (resumeData.clientInfomationTabData()?.sales_person) {
        <div class="manager-info-pill">
          <i class="fa fa-user-circle-o me-1" style="color: #64748b;"></i>
          <span style="color: #64748b; font-weight: 400;">Sales Rep:</span>
          <span class="manager-name ms-1">{{ resumeData.clientInfomationTabData()?.sales_person }}</span>
        </div>
      }
    </div>

    <div class="client-details-row mt-2 pt-2 border-top">
      @if (resumeData.clientInfomationTabData()?.address) {
        <div class="detail-item address"><i class="fa fa-map-marker" style="color: #64748b;"></i> {{ resumeData.clientInfomationTabData()?.address }}</div>
      }
      @if (resumeData.clientInfomationTabData()?.email) {
        <div class="detail-item"><i class="fa fa-envelope-o" style="color: #64748b;"></i> {{ resumeData.clientInfomationTabData()?.email }}</div>
      }
      @if (resumeData.clientInfomationTabData()?.contact_name) {
        <div class="detail-item"><i class="fa fa-user-o" style="color: #64748b;"></i> {{ resumeData.clientInfomationTabData()?.contact_name }}</div>
      }
      @if (resumeData.clientInfomationTabData()?.phone) {
        <div class="detail-item"><i class="fa fa-phone" style="color: #64748b;"></i> {{ resumeData.clientInfomationTabData()?.phone }}</div>
      }
    </div>
  </div>

  <!-- ── 2. Charts Section ── -->
  <div class="charts-section mb-2">
    <!-- Chart Panel 1: Oil Collected -->
    <div class="chart-panel pie-chart-container">
      <div class="chart-header">
        <div class="d-flex align-items-center justify-content-between w-100 px-2">
          <div class="text-start">
            <span class="chart-title">Oil Collected</span>
            <span class="chart-subtitle">Clean vs Waste Ratio</span>
          </div>
          <span class="badge-total-metric oil-metric">{{ totalOilFormatted() }}</span>
        </div>
      </div>
      <div class="chart-wrapper">
        @if (hasOilData()) {
          <wj-flex-pie #flexPie [itemsSource]="oilData" binding="value" bindingName="name" [innerRadius]="0.65" [header]="''">
            <wj-flex-pie-data-label [position]="'None'"></wj-flex-pie-data-label>
          </wj-flex-pie>
        } @else {
          <div class="chart-empty-state">
            <div class="empty-ring">
              <i class="fa fa-tint fa-lg" style="color: #94a3b8;"></i>
            </div>
            <span class="empty-title">No Collections Recorded</span>
            <span class="empty-desc">0.00 Gallons Collected</span>
          </div>
        }
      </div>
    </div>

    <!-- Chart Panel 2: Payment Status -->
    <div class="chart-panel pie-chart-container">
      <div class="chart-header">
        <div class="d-flex align-items-center justify-content-between w-100 px-2">
          <div class="text-start">
            <span class="chart-title">Payment Status</span>
            <span class="chart-subtitle">Debt Coverage</span>
          </div>
          <span class="badge-total-metric payment-metric">Paid: {{ totalPaidFormatted() }}</span>
        </div>
      </div>
      <div class="chart-wrapper">
        @if (hasPaymentData()) {
          <wj-flex-pie #flexPie2 [itemsSource]="paymentData" binding="value" bindingName="name" [innerRadius]="0.65" [header]="''">
            <wj-flex-pie-data-label [position]="'None'"></wj-flex-pie-data-label>
          </wj-flex-pie>
        } @else {
          <div class="chart-empty-state">
            <div class="empty-ring">
              <i class="fa fa-credit-card fa-lg" style="color: #94a3b8;"></i>
            </div>
            <span class="empty-title">No Payment History</span>
            <span class="empty-desc">$0.00 Outstanding Balance</span>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- ── 3. Section 1: General & Operational Info ── -->
  <div class="card-report p-0 overflow-hidden mb-2">
    <table class="report-table w-100">
      <thead>
        <tr class="table-section-header">
          <th colspan="2">
            <i class="fa fa-cogs me-2" style="color: #2563eb;"></i>General & Operational Info
          </th>
        </tr>
      </thead>
      <tbody>
        @for (item of pkiOperativesData; track item.pki; let odd = $odd) {
          <tr [class.odd-row]="odd">
            <td class="col-label">{{ item.pki }}</td>
            <td class="col-value">{{ item.value }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- ── 4. Section 2: Performance & Financial Status ── -->
  <div class="card-report p-0 overflow-hidden mb-2">
    <table class="report-table w-100">
      <thead>
        <tr class="table-section-header">
          <th colspan="2">
            <i class="fa fa-line-chart me-2" style="color: #10b981;"></i>Performance & Financial Status
          </th>
        </tr>
      </thead>
      <tbody>
        @for (item of pkiFinancialData; track item.pki; let odd = $odd) {
          <tr [class.odd-row]="odd">
            <td class="col-label">{{ item.pki }}</td>
            <td class="col-value" [class.text-highlight-debt]="item.pki === 'Current Debt' && item.value !== '$0.00'">
              {{ item.value }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- ── 5. Section 3: Commissions & Predictions ── -->
  <div class="card-report p-0 overflow-hidden mb-2">
    <table class="report-table w-100">
      <thead>
        <tr class="table-section-header">
          <th colspan="2">
            <i class="fa fa-handshake-o me-2" style="color: #6366f1;"></i>Commissions & Predictions
          </th>
        </tr>
      </thead>
      <tbody>
        @for (item of pkiBehaviorData; track item.pki; let odd = $odd) {
          <tr [class.odd-row]="odd">
            <td class="col-label">{{ item.pki }}</td>
            <td class="col-value">{{ item.value }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</app-document-viewer>